import es from './data/es.json';
import pt from './data/pt.json';

const traducciones = { es, pt };
export default traducciones;
